module.exports = __webpack_public_path__ + "static/img/poi-marker-red.b3e305cc.png";